let galleries

const ArticleHelper = {
 init: function() {
  galleries = document.querySelectorAll('.article-gallery')
  if (galleries) {
    this.resize()
    window.addEventListener('resize', () => this.resize())
  }
  const printBtn = document.querySelector('.print-btn')
  if (!printBtn) return
  printBtn.addEventListener('click', () => window.print())
 },

 resize: function() {
  setTimeout(() => {
    if (galleries) {
      galleries.forEach(item => {
        const parentWrapper = item.closest('.container--content')

        const parentWrapperComputedStyles = window.getComputedStyle(parentWrapper)
        const wrapperWidth = parseFloat(parentWrapperComputedStyles.width)
        const wrapperMargin = parseFloat(parentWrapperComputedStyles.marginLeft)
        const pageWidth = wrapperWidth + wrapperMargin * 2

        const itemWidth = item.matches('.article-gallery--with-tip') ? pageWidth : pageWidth * 0.8
        const itemMargin = (itemWidth - wrapperWidth) / 2

        item.style.width = `${itemWidth}px`
        item.style.marginLeft = `-${itemMargin}px`
      });
    }
  }, 1000)
 }
}

export default ArticleHelper
